export enum CaseDimensionLoaderId {
  productCaseDimensions = "productCaseDimensions",
}
